export default __webpack_public_path__ + "static/media/icon_benefits_business.fbee858f.svg";